// hooks/useBeforeUnload.ts
import { useEffect } from "react";

export const useBeforeUnload = (shouldWarn) => {
  useEffect(() => {
    const handler = (e) => {
      if (shouldWarn) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [shouldWarn]);
};
